import React from 'react';
import { useTranslation } from 'react-i18next';
import { getDirection, numToPrice, priceSum } from '../../utils/functions';

export default function Calculator({ accessories, wages, extras, deducts }) {
    const { t, i18n } = useTranslation();
    return (
        <div className='pricing'>
            <div className={`d-flex space-between ${getDirection(i18n.language) === 'rightToLeft' ? 'flex-row-reverse' :''} `}>
                <p>{t('Total accessories')} :</p>
                <p> {numToPrice(priceSum(accessories))} {t('rial')}</p>
            </div>
            <div className={`d-flex space-between ${getDirection(i18n.language) === 'rightToLeft' ? 'flex-row-reverse' :''} mt10`}>
                <p>{t('Total wages')} :</p>
                <p> {numToPrice(priceSum(wages))} {t('rial')}</p>
            </div>
            <div className={`d-flex space-between ${getDirection(i18n.language) === 'rightToLeft' ? 'flex-row-reverse' :''} mt10`}>
                <p>{t('Total extra')} :</p>
                <p> {numToPrice(priceSum(extras))} {t('rial')}</p>
            </div>
            <div className={`d-flex space-between ${getDirection(i18n.language) === 'rightToLeft' ? 'flex-row-reverse' :''} mt10`}>
                <p>{t('Total deduct')} :</p>
                <p> {numToPrice(priceSum(deducts))} {t('rial')}</p>
            </div>
            <div className={`d-flex space-between ${getDirection(i18n.language) === 'rightToLeft' ? 'flex-row-reverse' :''} mt10`}>
                <p>{t('Final total')} :</p>
                <p> {numToPrice(priceSum(accessories) + priceSum(wages) + priceSum(extras) - priceSum(deducts))} {t('rial')}</p>
            </div>
        </div>
    );
};